import { useMutation } from "@tanstack/react-query";

import { updateReviewedDataPoints } from "services";

import { invalidateQueriesByChunk } from "utils";

import { GET_FIELD_PRACTICES, UPDATE_REVIEWED_DATA_POINTS } from "consts";

export const useUpdateReviewedDataPoints = ({ fieldId }: { fieldId: string }) =>
  useMutation({
    mutationKey: [UPDATE_REVIEWED_DATA_POINTS, fieldId],
    mutationFn: updateReviewedDataPoints,
    onSuccess: () => {
      invalidateQueriesByChunk(GET_FIELD_PRACTICES, fieldId);
    },
  });
